export const dealersMap = {
	Viva_Brescia_Diesel: 'VIVABRESCIADIESEL SRL',
	Scar: 'SCAR LIVORNO SRL',
	HORIZON_MILANO: 'MILANO',
	HORIZON_GENOVA: 'GENOVA',
	HORIZON_TORINO: 'TORINO',
	STEFANELLI_SPA: 'STEFANELLI',
	GRUPPO_BIANCHESSI_AUTO_SRL: 'BIANCHESSI AUTO',
	CARRARO: 'Gruppo Carraro',
	Guadagni: 'Guadagni SpA',
	'CampaniaMotori-GruppoFarina': 'FARINA',
	KATANEAUTO_SRL: 'KATANE AUTO',
};
